/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Any
 *
 * 2 = Email
 *
 * 3 = SMS
 *
 * 4 = Call
 */
export enum NextContactMethod {
  Any = 1,
  Email = 2,
  SMS = 3,
  Call = 4,
}
